import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'rb-validation-rules',
  imports: [RouterOutlet],
  templateUrl: './validation-rules.component.html',
  styleUrl: './validation-rules.component.scss',
})
export class ValidationRulesComponent {}
